export default __webpack_public_path__ + "static/media/premier-bank-logo-secondary.c590d534.png";